
import 'aos/dist/aos.css'
import { computed, defineComponent, inject, reactive, watch } from 'vue'
import { useStore } from '@/store'
import ThreeScene from '@/components/Three/ThreeScene.vue'
import ThreeScreenshot from '@/components/Three/ThreeScreenshot.vue'
import ThreeRandselBag from '@/components/Three/ThreeRandselBag.vue'
import ThreeRandselAnimation from '@/components/Three/ThreeRandselAnimation.vue'
import RandselLoadingCircle from '@/components/Three/RandselLoadingCircle.vue'
import positionSettings from '@/settings/position-settings.json'
import SentrySingleton from '@/singletons/sentry-singleton'

export default defineComponent({
  name: 'ThreeFullorder',
  components: {
    ThreeScene,
    ThreeScreenshot,
    ThreeRandselBag,
    ThreeRandselAnimation,
    RandselLoadingCircle
  },
  setup() {
    const store = useStore()
    const emitter: any = inject('emitter')
    const currentTab = computed(() => store.getters.currentTab)
    const isAnimationFinished = computed(() => store.getters.isAnimationFinished)

    // prettier-ignore
    watch(() => currentTab.value, (tab) => {
      try {
        const pos = positionSettings.cameraPositionsFullorder[tab].pos
        const open = positionSettings.cameraPositionsFullorder[tab].bagOpen
        if(isAnimationFinished.value) {
          emitter.emit('animateBag', {pos, open, instant: false})
        }
      }
      catch(err) {
        SentrySingleton.instance.captureException(err)
      }
    })

    return {
      currentTab
    }
  }
})
